export default __webpack_public_path__ + "static/media/prevArrow.c3c906e2.svg";